import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../api";
import Seo from "../components/Seo";

export function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) return setStatus("unknown");
    let ticks = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") return setStatus("paid");
      } catch { /* retry */ }
      ticks += 1;
      if (ticks < 10) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="billing-success">
      <Seo title="Payment status | CourierRadar" noindex />
      {status === "paid" ? (
        <>
          <h1 className="text-3xl font-extrabold tracking-tight">You're subscribed</h1>
          <p className="text-sm text-zinc-600 mt-3">Your plan is active. Enjoy CourierRadar.</p>
          <Link to="/account" data-testid="billing-success-account" className="inline-block mt-6 bg-black text-white px-6 py-3 rounded-lg text-sm font-medium">Go to account</Link>
        </>
      ) : status === "pending" ? (
        <>
          <h1 className="text-2xl font-bold">Payment processing</h1>
          <p className="text-sm text-zinc-600 mt-3">We're confirming your payment — this can take a minute. Your plan activates automatically.</p>
        </>
      ) : (
        <p className="text-sm text-zinc-500">Confirming your payment…</p>
      )}
    </div>
  );
}

export function BillingCancel() {
  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="billing-cancel">
      <Seo title="Checkout cancelled | CourierRadar" noindex />
      <h1 className="text-2xl font-bold">Checkout cancelled</h1>
      <p className="text-sm text-zinc-600 mt-3">No charge was made. You can subscribe anytime.</p>
      <Link to="/pricing" className="inline-block mt-6 text-sm font-semibold text-[#0A0A0A]">Back to pricing</Link>
    </div>
  );
}
